import { useLocation } from 'react-router';

import { resolveRoutePermission } from '@/utils/access';

import { useAccess } from './useAccess';

type TRouteAccess = {
  isAllowed: boolean;
  isReady: boolean;
};

const useRouteAccess = (): TRouteAccess => {
  const { pathname } = useLocation();
  const { can, isReady } = useAccess();

  const permission = resolveRoutePermission(pathname);

  return {
    isReady,
    isAllowed: isReady && (!permission || can(permission)),
  };
};

export type {
  TRouteAccess,
};
export {
  useRouteAccess,
};
